import {Component, ViewChild,  ElementRef} from '@angular/core'; //, Inject, forwardRef
import {PopoverController, NavController, ViewController, Platform, MenuController, ModalController, Content} from 'ionic-angular';

//import { Geolocation } from '@ionic-native/geolocation';
//import { SplashScreen } from '@ionic-native/splash-screen';
//import { StatusBar } from '@ionic-native/status-bar';
//import { Storage } from '@ionic/storage';
//import { GoogleMaps,GoogleMap, GoogleMapsEvent, LatLng, CameraPosition, MarkerOptions, Marker} from '@ionic-native/google-maps';
import {MenuService} from '../components/multilevel-menu/menu';

import {TranslateService, LangChangeEvent} from '@ngx-translate/core'; //DefaultLangChangeEvent
import {CoverageService} from '../services/coverage.service'

//import { SuperTabsController } from 'ionic2-super-tabs';


//import {CoveragesPage} from './pages/tabs/coverage'
@Component({
  template: `
  <ion-list class="select-page">
      <ion-row>
      
        <button class="header-buttons is-web" [strong]="this.lang==='fr'" ion-button clear (click)="translateTo('fr')">
          FR         
        </button>

        <button class="header-buttons is-web header-buttons-lang" ion-button clear (click)="translateTo('ang')">
          /
        </button>

        <button class="header-buttons is-web" [strong]="this.lang==='ang'" ion-button clear (click)="translateTo('ang')">
          EN
        </button>
      </ion-row>

      <ion-row class="button-currency">
        <button class="header-buttons is-web button-margin-left" [strong]="this.currency==='euro'" ion-button clear (click)="currencyTo('euro')">
          €           
        </button>

        <button class="header-buttons is-web header-buttons-lang" ion-button clear (click)="currencyTo('euro')">
          /
        </button>

        <button class="header-buttons is-web" [strong]="this.currency==='dollar'" ion-button clear (click)="currencyTo('dollar')">
          $
        </button>
      </ion-row>

      
      
    </ion-list>
  `
})
export class SelectLangPage {
  lang;
  langTxt;
  currency;
  currencyTxt;

  constructor(
    public viewCtrl: ViewController,
    public coverageService: CoverageService,
    // private events: Events,
    public translateService: TranslateService,
    
  ) {

    this.lang = this.coverageService.getLang().subscribe(
      data => {
        this.lang = data;
      },  e => console.log('onError: %s', e)

    ); 
    this.lang = this.translateService.currentLang;

    //this.coverageService.initCurrency().then(() => {    
    
    //})

    this.currency = 'euro';
    this.currencyTxt = '€';

    this.currency = this.coverageService.getCurrency2().then(
      data => {
        this.currency = data;  
        if(this.currency==='dollar') this.currencyTxt = "$"; else this.currencyTxt = "€"; 
   
      },  e => console.log('onError: %s', e)

    ); 

    this.currency = this.coverageService.getCurrency().subscribe(
      data => {
        this.currency = data;  
        if(this.currency==='dollar') this.currencyTxt = "$"; else this.currencyTxt = "€";    

      },  e => console.log('onError: %s', e)

    ); 
    

  }

  close() {
    this.viewCtrl.dismiss();
  }

  translateTo(lang){
    this.coverageService.setLang(lang);
    this.close();
  }

  currencyTo(currency){
    this.coverageService.setCurrency(currency);
    this.close();
  }

  changeFilter(type){
      //this.orderBy = 'aware.facebook.count';

      //this.events.publish('changeFilter', type);
      this.close();
  }

}


@Component({
  templateUrl: 'app.html'
})
export class MyApp {
  //@ViewChild('contentmenu') nav_menu: NavController;
  @ViewChild('app') nav: NavController;
  @ViewChild('content') elementView: ElementRef;
  @ViewChild(Content) content2: Content;

  root: any = 'CoverageHome';
  //root_menu: any = MyMenu;

  selectedCategory
  categories
  

  pages: Array<{ title: string, component: any }>;

  lang
  langTxt
  currency
  currencyTxt
  //storage
  navColor

  apiKey: any;
  data_coverage: any; //FirebaseObjectObservable<any[]>
  data_home: any; //FirebaseObjectObservable<any[]>
  data_news: any;
  data_service: any;
  data_shop: any;
  data_lookbook
  story_tailoring: any;
  data_bags

  data_collections 
  story_collections


  story_service
  story_shop
  mymodel
  story_collection

  translateService

  zone
  distance
  //content

  basket_nb

  data_contact

  menu_shop

  newsletter

  cookieText
  cookieText2

  minheight
  elHeight

  splitPaneState: boolean;

  site

  constructor(
    public platform: Platform,
    //    @Inject(forwardRef(() => TranslateService)) translate,
    
    public translate: TranslateService,
    public menuCtrl: MenuController,
    //private geolocation: Geolocation,
    //private splashScreen: SplashScreen,
    //private statusBar: StatusBar,
    //public superTabsCtrl: SuperTabsController,
    public MenuService: MenuService,
    public modalCtrl: ModalController,
    public coverageService: CoverageService,
    public popoverCtrl: PopoverController,

    //@Inject(forwardRef(() => CoverageService)) coverageService,
    //@Inject(CoverageService) coverageService:CoverageService 
  ) {
    
    this.initializeApp();
    //this.coverageService.init(false);
    

    this.minheight = 700;
    this.elHeight = 0;

    this.splitPaneState = false;

    translate.setDefaultLang('fr');
    //this.lang = 'fr';

    this.translateService = translate

    this.site = this.coverageService.get_info(1);  
     
    this.selectedCategory = {};    
    this.coverageService.getCat().subscribe(data => { 
      this.selectedCategory = data; 
      this.coverageService.removeNotif();
      //console.log('cat',data); 
    });


    this.coverageService.getColor().subscribe(color => { 
      this.navColor = color; 
      //this.coverageService.removeNotif();
      //console.log('cat',data); 
    });

    

    this.coverageService.initCurrency().then((res) => {    
      this.currency = res;
    })
    
    this.coverageService.initLang().then(() => {

      setTimeout(() => {
        this.checkCookie();
      },1000);      
    
    })

    //if(this.elHeight < this.minheight)  this.toggleFooter()
    this.mymodel = '';  
    
  }

  
  sendCat(data) {
      this.coverageService.sendCat(data);
  }

  initializeApp() {
    this.platform.ready().then(() => {

      //ready

    });
  }

  ngOnInit() {//ngOnInit

    // listen to the service worker promise in index.html to see if there has been a new update.
		// condition: the service-worker.js needs to have some kind of change - e.g. increment CACHE_VERSION.
		/*window['isUpdateAvailable']
    .then(isAvailable => {
      if (isAvailable) {
        const toast = this.toastCtrl.create({
          message: 'New Update available! Reload the webapp to see the latest juicy changes.',
          position: 'bottom',
          showCloseButton: true
        });
        toast.present();
      }
    });*/

    this.coverageService.coverage2(1273).then(coverage => this.data_home = coverage)
    this.coverageService.coverage2(1361).then(coverage => this.data_news = coverage)    
    this.coverageService.coverage2(1834).then(coverage => this.data_bags = coverage)
    this.coverageService.coverage2(1859).then(coverage => this.data_contact = coverage)

    this.coverageService.coverage2(1543).then(coverage => this.story_tailoring = coverage)
    this.coverageService.coverage2(1544).then(coverage => this.story_service = coverage)
    this.coverageService.coverage2(1545).then(coverage => this.story_shop = coverage)
    this.coverageService.coverage2(1553).then(coverage => this.story_collections = coverage)
    

    this.translateService.onLangChange.subscribe((event: LangChangeEvent) => {
      //console.log(event)
      //this.translateService.use(event.lang);
      this.lang = event.lang;
    
      if(this.lang==='fr') this.categories = this.MenuService.getAll();
      else this.categories = this.MenuService.getAll2();

      this.coverageService.get_info_cookie().then(data => { 
        if(data != 0) 
          {
            this.site = this.coverageService.get_info(data); 
            //this.site = this.coverageService.get_info(2);  //if(this.site.menu === 2) 
            if(data == 1) this.categories = this.MenuService.getAll();
            else if(data == 2) {
              this.categories = this.MenuService.getAware();
              
            }
            else if(data == 3) {
              this.categories = this.MenuService.getCDM();
            }

          }
      });

      if(this.lang==='ang') this.langTxt = 'en'; else this.langTxt = 'fr';


    });

    this.lang = this.coverageService.getLang().subscribe(
      data => {
        this.lang = data;
        if(this.lang==='ang') this.langTxt = 'en'; else this.langTxt = 'fr';

      },  e => console.log('onError: %s', e)

    ); 
    this.lang = this.translateService.currentLang;
    if(this.lang==='ang') this.langTxt = 'en'; else this.langTxt = 'fr';


    //this.coverageService.initCurrency().then(() => {    
    
    //})

    this.currency = 'euro';
    this.currencyTxt = '€';

    this.currency = this.coverageService.getCurrency2().then(
      data => {
        this.currency = data;  
        if(this.currency==='dollar') this.currencyTxt = "$"; else this.currencyTxt = "€"; 
   
      },  e => console.log('onError: %s', e)

    ); 

    this.currency = this.coverageService.getCurrency().subscribe(
      data => {
        this.currency = data;  
        if(this.currency==='dollar') this.currencyTxt = "$"; else this.currencyTxt = "€";    

      },  e => console.log('onError: %s', e)

    ); 

  }

  ngAfterViewInit() {

    this.elHeight = this.elementView.nativeElement.getBoundingClientRect().height;
    this.setSplitPane();
    //console.log(this.elHeight);
    
  }

  checkCookie() {

    this.coverageService.checkVisit()
    .then((res) => {

      console.log('ressssss', res)
      
      if(res==='cookie') this.goToCoverage(false, {id: 2388, slug: 'legal', data: {}});
      else if(res==='newsletter') this.goToNewsletter(null)	
      		
    });

      /*if(!this.localSt.retrieve('e-cookie')) {

        this.goToCookie(true);
        this.localSt.store('e-cookie', '1');
        
      }
      else if(!this.localSt.retrieve('e-newsletter')) {

            this.goToNewsletter(true);
            this.localSt.store('e-newsletter', '1');

      }*/
  }

  onMenuSelect(cat) {

    if(cat.story){

      //console.log(this.selectedCategory.story, cat.story, cat.index)
      /*if((this.selectedCategory.story == cat.story) && cat.slug) {
        console.log('index:', cat.index)
        //this.superTabsCtrl.slideTo(cat.index, cat.story);
        
      } else {*/
        console.log('no:', cat.index)

        var coverage = {id: cat.id, slug: cat.slug, data: {}};

        if(cat.id=='feed') this.goToFeed(null, '0');
        else if(cat.id=='list') this.goToList(null, '0');
        else if(cat.id=='class') this.goToClass(null, '0');
        else if(cat.id=='tree') this.goToTree(null, '0');
        else if(cat.id=='search') this.goToSearch(null, '0');
       
        else if(cat.id==1223) this.goToProductList(1, 'sacs');
        else if(cat.id==1834) this.goToBags(1, 2);

        else if(cat.story) this.goToCoverage(false, coverage); //moche
        
        //else if(cat.story==1543) this.goToActive(false, cat.index);
        //else if(cat.story==1544) this.goToService(false, cat.index);
        //else if(cat.story==1553) this.goToCollections(false, cat.index);
        //else if(cat.story==1545) this.goToShop(false, cat.index);
        

  
      //}
    } else {

      if(cat.id==10) this.goToProductList(1, 'vestes');
      else if(cat.id==2) this.goToProductList(1, 'sacs');
      else if(cat.id==10000) this.goToProductList(1, 'sneakers');
      else if(cat.id==40000) this.goToProductList(1, 'sunglasses');
      //else if(cat.id==1553) this.goToLookbook(1, 2);
      //else if(cat.id==1234 || cat.id==1297 || cat.id==1338) this.goToActive(1, 2);
      //else if(cat.id==1430 || cat.id==1376 || cat.id==1434) this.goToService(1, 2);
      else if(cat.id==1361) this.goToNews(1, this.data_news);

      else if(cat.id==666) this.goToStore();


      else if(cat.id=='lazy') this.goToLazy(null, cat.lazy, {slug: cat.slug});
      else if(cat.id=='coverage') this.goToCoverageTabs(null, {slug: cat.slug});

    }

    this.sendCat(cat);

  }

  goToStore() {
    if(this.currency==='dollar') window.open('https://store.e-eclectic.com/us/', '_blank');
    else window.open('https://store.e-eclectic.com/eu/', '_blank');

  }



  setSplitPane() { 
    //window.innerWidth
    //console.log('this.platform.width()', this.platform.width(), window.innerWidth)
		if (window.innerWidth >= 768) {
			this.splitPaneState = false;
		} else {
			this.splitPaneState = true;
    }
    
    //console.log ('split', this.platform.width(), this.splitPaneState)
  }
  
  getSplitPane() {
		return this.splitPaneState;
	}

  subscribeToNewsLetter(event, email: string) {
    
    this.mymodel = null;

    this.coverageService.subscribeToNewsLetter2(email, this.currency)
		.then((res) => {

			//if(res==='success') this.nav.pop();			
			
		});

  }

  

  goToNewsletter(event) {
    let profileModal = this.modalCtrl.create('FormNewsletter', {});
    profileModal.present();
  }  

  openLink(url: string) {
    window.open(url, '_blank');
  }

  goToCall() {
    window.open('tel:0650092945', '_top');
  }

  toggleFooter() {
    //this.showToolbar = !this.showToolbar;
    this.content2.resize();

    this.setSplitPane()
  }

  inputFocusOut(newValue) {
    if(!this.newsletter) this.mymodel = null;    //console.log(newValue)

  }

  inputkeypress(newValue) {
    this.mymodel = 'newValue';
    this.newsletter = true;
  }

  inputFocus(newValue) {
    this.mymodel = 'newValue';
    this.newsletter = null;
  }

  translateTo(lang){
    
    this.coverageService.setLang(lang);
    this.lang = lang;

  }

  currencyTo(currency){
    this.coverageService.setCurrency(currency);
    //this.close();
  }

  goToCoverage(event, coverage) {
    this.nav.push('CoverageHome', coverage);
  }

  goToCoverageTabs(event, coverage) {
    console.log(coverage)
    this.nav.push('CoverageTabs', coverage);
  }

  goToBags(event, coverage) {
    this.nav.push('CoverageHome', this.data_bags);
  }

  goToHome(event, coverage) {

    this.coverageService.clearCat();
    this.nav.setRoot('CoverageHome', this.data_home);
    this.menuCtrl.close();

  }

  goToShop(event, tab) {

    this.coverageService.clearCat();

    let data = this.story_shop;
    data.tab = tab;
    this.nav.push('CoverageStory', data);
    //this.coverageService.resetStorage();
    this.menuCtrl.close();

  }

  goToService(event, tab) {

    let data = this.story_service;
    data.tab = tab;

    this.nav.push('CoverageStory', data);
  }

  goToCollections(event, tab) {

    let data = this.story_collections;
    data.tab = tab;

    this.nav.push('CoverageStory', data);
  }

  goToActive(event, tab) {

    let data = this.story_tailoring;
    data.tab = tab;

    this.nav.push('CoverageStory', data);
  }

  goToNews(event, coverage) {
    this.nav.push('CoverageHome', coverage);
  }

  /*goToCoveragePost(event, coverage) {
    this.nav.push(CoveragePost, {
      coverage: coverage
    });
  }

  */

  goToProduct(event, item) {
    this.nav.push('ProductList', {
      item: item
    });
  }

  goToContact(event, coverage) {
    this.nav.push('CoverageHome', this.data_contact);
    
    this.menuCtrl.close();
  }

  goToProductList(event, cat) {
    this.nav.push('ProductList', {
      filter: cat
    });
  }

  goToList(event, cat) {
    this.nav.push('CoverageList', {
      filter: cat
    });
  }

  goToFeed(event, cat) {
    this.nav.push('CoverageFeed', {
      filter: cat
    });
  }

  goToClass(event, cat) {
    this.nav.push('HomeClass', {
      filter: cat
    });
  }

  goToTree(event, cat) {
    this.nav.push('TreeView', {
      filter: cat
    });
  }

  goToSearch(event, cat) {
    this.nav.push('Search', {
      filter: cat
    });
  }

  goToLazy(event, lazy, coverage) {
    this.nav.push(lazy, {
      coverage: coverage
    });
  }  

  presentPopover(myEvent) {
    let popover = this.popoverCtrl.create(SelectLangPage, {}, {cssClass: 'popover-ios'});
    popover.present({
      ev: myEvent
    });
  }

  





}



// WEBPACK FOOTER //
// ./src/app/app.component.ts